import script from "./device-change.vue?vue&type=script&setup=true&lang=js"
export * from "./device-change.vue?vue&type=script&setup=true&lang=js"

import "./device-change.vue?vue&type=style&index=0&id=6536ff7e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6536ff7e"]])

export default __exports__